import { Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const accommodation = <>
  <Accordion.Body>
    The cottage has been refurbished in keeping with its quaint nature and has a fully equipped kitchen and bathroom. There is a private garden to the back and front of the property; patio furniture and a small BBQ allow you to dine outside during the warmer weather.
  </Accordion.Body>
  <Accordion.Body>
    The living room has plenty of seating with one 3-seater sofa, one large armchair, one smaller chair and a large pouffe for sitting or putting your feet up. The ingenious dining table unfolds to seat up to 6 people comfortably. There's a wood burning stove to keep you cosy on cooler evenings and efficient gas central heating.
  </Accordion.Body>
  <Accordion.Body>
    Entertainment wise, there's a flat screen TV with a BT box for you to watch mainstream channels, BBC iPlayer and other apps plus Netflix. Free high-speed Wi-Fi is also provided.
  </Accordion.Body>
  <Accordion.Body>
    Overlooking the garden is the fully equipped kitchen which has a full-size electric fan oven, gas hob, microwave, Nespresso Coffee machine, full size fridge freezer and washer dryer. A wide range of utensils, crockery and glasses are provided.
  </Accordion.Body>
  <Accordion.Body>
    The light, well designed bathroom has a full-size bath and electric shower with a heated towel rail and plenty shelving for toiletries.
  </Accordion.Body>
  <Accordion.Body>
    The master bedroom has a comfortable King size bed with a memory foam mattress, a small sofa, built in wardrobe, chest of drawers and 2 bedside tables. The room is beautifully decorated and has a calming feel to it.
  </Accordion.Body>
  <Accordion.Body>
    The second bedroom is furnished with 2 comfortable single beds, a chest of drawers, built in wardrobe and bedside table. The room has been thoughtfully decorated and looks out onto the back garden.
  </Accordion.Body>
  <Accordion.Body>
    A travel cot is available for babies.
  </Accordion.Body>
  <Accordion.Body>
    Outside the cottage, to the front there is a pretty garden and a driveway. Parking is also available on the road outside (no permit needed). To the back there is a secure garden with a back gate overlooking the fields and Drylaw Hill, perfect for children and dogs.
  </Accordion.Body>
  <Accordion.Body>
    There is a lovely garden room with a comfortable sofa/daybed, drop leaf table and electric heater, the perfect place for your evening whisky or G & T. Garden chairs, a portable BBQ, a table and 4 chairs are also provided for you to use.
  </Accordion.Body>
  <Accordion.Body>
    The cottage is on one floor; however, it isn't suitable for wheelchair access.
  </Accordion.Body>
  <Accordion.Body>
    Dogs are welcome as long as they are well behaved.
  </Accordion.Body>
  <Accordion.Body>
    <div>
      <h4 className='d-flex justify-content-center'>Amenities</h4>
    </div>
    <div className='d-flex space-around'>
      <div className='w-50'>
        <ul>
          <li>
            Hair dryer
          </li>
          <li>
            Washing machine
          </li>
          <li>
            Tumble dryer
          </li>
          <li>
            Towels, bed linen
          </li>
          <li>
            Hangers
          </li>
          <li>
            Iron
          </li>
          <li>
            Ironing Board
          </li>
          <li>
            Flat Screen TV
          </li>
          <li>
            BT TV box
          </li>
          <li>
            Netflix
          </li>
          <li>
            Log burning stove
          </li>
          <li>
            Gas central heating
          </li>
        </ul>
      </div>
      <div className='w-50'>
        <ul>
          <li>
            Smoke & heat alarms
          </li>
          <li>
            Carbon monoxide alarm
          </li>
          <li>
            High speed Wi-Fi
          </li>
          <li>
            Crockery, glasses & cutlery
          </li>
          <li>
            Nespresso coffee machine
          </li>
          <li>
            Full size oven
          </li>
          <li>
            Microwave
          </li>
          <li>
            Full size fridge freezer
          </li>
          <li>
            Outdoor dining table and chairs
          </li>
          <li>
            Sun loungers
          </li>
          <li>
            Portable BBQ
          </li>
          <li>
            Free parking on premises - 
            <br/>
            driveway and on road (no permit required)
          </li>
          <li>
            Outside drying facilities
          </li>
        </ul>
      </div>
    </div>
  </Accordion.Body>
</>

export const travel = <>
  <Accordion.Body>
    <h4>Buses</h4>
    There are regular, direct bus services from the village to the centre of Edinburgh (every 30 minutes during peak times). These are run by Lothian Buses (Dunbar to Edinburgh) and Border Buses (Berwick upon Tweed to Edinburgh). Please check the links for latest timings:
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.lothianbuses.com/wp-content/uploads/2021/08/X7_210912.pdf' target='_blank' rel='noopener noreferrer'>
      Lothian Buses
    </a>
    <br/>
    <a href='https://www.bordersbuses.co.uk/services/BORD/253?date=2022-02-02&direction=outbound' target='_blank' rel='noopener noreferrer'>
      Border Buses
    </a>
  </Accordion.Body>
  <Accordion.Body>
    There is also a service from the village to North Berwick (every 2 hours at present. It's worth taking this bus on a clear day for the fabulous views of the countryside and coast:
  </Accordion.Body>
  <Accordion.Body>
    <h4>Rail</h4>
    Plans for the railway station in East Linton to reopen are in progress and scheduled for some time in 2023. This will provide long awaited direct services to Edinburgh and Newcastle.
  </Accordion.Body>
  <Accordion.Body>
    The nearest railway station at present is Drem (a 10-minute drive) where there is a regular service to Edinburgh. For mainline services, Dunbar and Edinburgh serve the LNER service from London Kings Cross and the Cross Country train services to Plymouth.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Air</h4>
    The nearest airport is Edinburgh, you can get to the cottage by taking the tram into Princes Street in Edinburgh, then taking the X7 bus to East Linton.
  </Accordion.Body>
</>

export const town = <>
  <Accordion.Body>
    East Linton is a picturesque country village located between Haddington and Dunbar. The village is situated on the River Tyne, 22 miles east of Edinburgh. It's one of the prettiest villages in East Lothian, steeped in history and surrounded by some of the oldest buildings in Scotland. It remains a vibrant community with great shops, a couple of good pubs, beautiful countryside, and good transport links to surrounding towns and Edinburgh.
  </Accordion.Body>
  <Accordion.Body>
    A bridge was built over the River Tyne during the 16th Century, making East Linton a staging post on the Great Northern Road between Edinburgh and London. The village developed over the years due to its location and the name Linton is most probably derived from the village waterfall, the Linn (or Lynn).
  </Accordion.Body>
  <Accordion.Body>
    The centre point of the village is the distinctive fountain with its four cherubs, built in 1882 and recently refurbished. Behind the fountain is St Andrew's Church, now a place of residence. The large clock in the tower known locally as <b>Auld Jessie</b> was installed to commemorate Queen Victoria's Jubilee and is kept in fine working order.
  </Accordion.Body>
  <Accordion.Body>
    At one time the village was full of working mills which were powered by the River Tyne, these included linen and flour mills, plus a distillery. <b>Preston Mill</b> which was one of these mills was built around 1599 and is one of the main historical attractions, featuring in recent times in the American hit TV series <b>Outlander</b> (visitors can still see working machinery on a tour during the summer months). <b>Phantassie Doo'cot</b>, nearby is a beehive shaped dovecot from the 16th century.
  </Accordion.Body>
  <Accordion.Body>
    East Linton also had its own <b>livestock market</b>, a distinctive octagonal building which can still be seen today if you visit The Mart to buy your groceries or attend the regular weekend Craft Market.
  </Accordion.Body>
  <Accordion.Body>
    The remaining working parish church, <b>Prestonkirk</b> was built in the 18th Century but retains its original chancery dating from the 13th century. One of the graves in the church yard belongs to Andrew Meikle who was the inventor of the threshing machine.
  </Accordion.Body>
  <Accordion.Body>
    Another famous Lintonian was John Rennie, the civil engineer who was born at Phantassie in 1761. John started working as a millwright with Andrew Meikle then studied at Edinburgh University. In 1791 he moved to London and is most famous for building Waterloo Bridge and London Bridge.
  </Accordion.Body>
  <Accordion.Body>
    East Linton has a long tradition of landscape painting. In the later 19th century East Linton produced several artists of renown known as the <b>East Linton School</b>.
  </Accordion.Body>
</>

export const golf = <>
  <Accordion.Body>
    Known as Scotland's Golf Coast the area has the greatest concentration of Championship links golf courses in the world and is rated as being the best in Scotland. Numerous famous courses are on the doorstep, Muirfield, Gullane and North Berwick to name a few. With twenty-one links and parkland courses, East Lothian is a golfer's paradise. Descriptions below are in order of proximity to Lynn Cottage:
  </Accordion.Body>
  <Accordion.Body>
    <h4>Winterfield (Dunbar) - 5.8 miles</h4>
    <a href='https://winterfieldgc.com' target='_blank' rel='noopener noreferrer'>
      winterfieldgc.com
    </a>
    <br/>
    01368 863562
  </Accordion.Body>
  <Accordion.Body>
    <h4>Glen (North Berwick East Links) - 6.6 miles</h4>
    <a href='https://glengolfclub.co.uk' target='_blank' rel='noopener noreferrer'>
      glengolfclub.co.uk
    </a>
    <br/>
    01620 892726
  </Accordion.Body>
  <Accordion.Body>
    <h4>North Berwick (West Links) - 6.9 miles</h4>
    <a href='https://www.northberwickgolfclub.com' target='_blank' rel='noopener noreferrer'>
      northberwickgolfclub.com
    </a>
    <br/>
    01620 892135
  </Accordion.Body>
  <Accordion.Body>
    <h4>Dunbar - 7.4 miles</h4>
    <a href='https://dunbargolfclub.com' target='_blank' rel='noopener noreferrer'>
      dunbargolfclub.com
    </a>
    <br/>
    01620 892135
  </Accordion.Body>
  <Accordion.Body>
    <h4>Luffness - 9 miles</h4>
    <a href='https://luffnessnew.com' target='_blank' rel='noopener noreferrer'>
      luffnessnew.com
    </a>
    <br/>
    01620 843336
  </Accordion.Body>
  <Accordion.Body>
    <h4>Muirfield - 9.3 miles</h4>
    <a href='https://muirfield.org.uk' target='_blank' rel='noopener noreferrer'>
      muirfield.org.uk
    </a>
    <br/>
    01620 842123
  </Accordion.Body>
  <Accordion.Body>
    <h4>Archerfield - 9.4 miles</h4>
    <a href='https://archerfieldgolfclub.com' target='_blank' rel='noopener noreferrer'>
      archerfieldgolfclub.com
    </a>
    <br/>
    01620 897050
  </Accordion.Body>
  <Accordion.Body>
    <h4>Gullane No.2 - 9.9 miles</h4>
    <a href='https://gullanegolfclub.co.uk' target='_blank' rel='noopener noreferrer'>
      gullanegolfclub.co.uk
    </a>
    <br/>
    01620 842255
  </Accordion.Body>
  <Accordion.Body>
    <h4>Kilspindie (Aberlady) - 10 miles</h4>
    <a href='https://kilspindiegolfclub.co.uk' target='_blank' rel='noopener noreferrer'>
      kilspindiegolfclub.co.uk
    </a>
    <br/>
    01875 870358
  </Accordion.Body>
  <Accordion.Body>
    <h4>Gifford - 10 mile</h4>
    <a href='https://giffordgolfclub.com' target='_blank' rel='noopener noreferrer'>
      giffordgolfclub.com
    </a>
    <br/>
    01620 810591
  </Accordion.Body>
  <Accordion.Body>
    <h4>Longniddry - 11 mile</h4>
    <a href='https://longniddrygolfclub.co.uk' target='_blank' rel='noopener noreferrer'>
      longniddrygolfclub.co.uk
    </a>
    <br/>
    01875 852141
  </Accordion.Body>
  <Accordion.Body>
    <h4>Craigielaw (Longniddry) - 11 miles</h4>
    <a href='https://www.craigielawgolfclub.com' target='_blank' rel='noopener noreferrer'>
      craigielawgolfclub.com
    </a>
    <br/>
    01875 870800
  </Accordion.Body>
  <Accordion.Body>
    <h4>Castle Park (Gifford) - 12 miles</h4>
    <a href='https://castleparkgolfclub.co.uk' target='_blank' rel='noopener noreferrer'>
      castleparkgolfclub.co.uk
    </a>
    <br/>
    01620 810733
  </Accordion.Body>
  <Accordion.Body>
    <h4>Royal Musselburgh (Prestonpans) - 16 miles</h4>
    <a href='https://www.royalmusselburgh.co.uk' target='_blank' rel='noopener noreferrer'>
      royalmusselburgh.co.uk
    </a>
    <br/>
    01875 819000
  </Accordion.Body>
  <Accordion.Body>
    <h4>Musselburgh Links - 16 miles</h4>
    <a href='https://musselburgholdlinks.co.uk' target='_blank' rel='noopener noreferrer'>
      musselburgholdlinks.co.uk
    </a>
    <br/>
    0131 653 5122
  </Accordion.Body>
  <Accordion.Body>
    <h4>Musselburgh - 18 miles</h4>
    <a href='https://www.themusselburghgolfclub.com' target='_blank' rel='noopener noreferrer'>
      themusselburghgolfclub.com
    </a>
    <br/>
    0131 665 2005
  </Accordion.Body>
</>

export const beaches = <>
  <Accordion.Body>
    <h4>Ravensheugh Sands - 4 miles</h4>
    Part of the John Muir Country Park, Tyninghame Links, otherwise known as Ravensheugh is one of the finest beaches in the south of Scotland. Walking from the car park via one of the many paths which wind their way through the forest, you'll come out onto the huge sandy unspoilt bay with views of the Bass Rock, the Isle of May and Fife. Great for walking at all times of year and for a picnic in the summer. Pop into Tyninghame Smithy on the way back for a light lunch or great cakes.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Bellhaven Bay - 5.4 miles</h4>
    Part of the John Muir Country Park, this is a spectacular beach with low sheltering sand dunes, salt marsh and grasslands. Great for walking and popular with surfers (you can book lessons at Belhaven Surf School - <a href='https://c2csurfschool.com/' target='_blank' rel='noopener noreferrer'>
    c2csurfschool.com
    </a> ), this is one of the most photographed beaches in the area with its famous 'Bridge to Nowhere'.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Milsey or North Berwick East Beach - 6.4 miles</h4>
    Great family beach near the town centre and the Scottish Seabird Centre, overlooking The Bass Rock and Fife. There is a paddling pool built into the rocks providing a safe area for children to splash around.
  </Accordion.Body>
  <Accordion.Body>
    <h4>North Berwick West Beach - 6.4 miles</h4>
    This long stretch of sand overlooks the island of Craigleith. The beach is parallel to the main street and is just in front of a putting green that is open during the summer.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Yellowcraig - 8.3 miles</h4>
    With spectacular views over to the 1885 lighthouse on Fidra Island which is said to be the inspiration for Robert Louis Stevenson's book Treasure Island, the beach is very popular with families. There is an adventure playpark, a great network of nature trails and a BBQ area.
  </Accordion.Body>
  <Accordion.Body>
    Information about the above beaches and others further afield can be found on the link below:
    <br/>
    <a href='https://visiteastlothian.org/explore/coast/coastal-car-parks' target='_blank' rel='noopener noreferrer'>
      visiteastlothian.org/explore/coast/coastal-car-parks
    </a>
  </Accordion.Body>
</>

export const walking = <>
  <Accordion.Body>
    Walking trails crisscross the area, the John Muir Way and Saltire Trail going right through the village. There are also many fascinating walks near and around East Linton itself, including routes to Pencraig Brae, Smeaton Lake, Hailes Castle and Tyninghame. For more information on these and others and to download a route map, please follow the link below:
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://elcv.org.uk/wp-content/uploads/2020/08/Walks-Around-East-Linton-v2.pdf' target='_blank' rel='noopener noreferrer'>
      www.elcv.org.uk (East Linton)
    </a>
  </Accordion.Body>
  <Accordion.Body>
    The walk from the village to <b>Traprain Law</b> will take you along the banks of the River Tyne, past Hailes Castle then over farmland to one of the most distinctive landmarks in the county. Once home to the Iron Age Votodini tribe and occupied up to the Roman withdrawal, you can still see remains of dwellings at the top. The largest hoard of Roman silver outside the Roman Empire was discovered here in 1919. If you don't want to walk all the way from the village there is a car park at the foot of the law.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://elcv.org.uk/wp-content/uploads/2018/02/1P-East-Linton-to-Traprain-Law.pdf' target='_blank' rel='noopener noreferrer'>
      www.elcv.org.uk (Traprain)
    </a>
  </Accordion.Body>
  <Accordion.Body>
    One of Scotland's Great Trails, the <b>John Muir Way</b> has routes in East Lothian suitable for both walkers and cyclists offering a fantastic sample of its landscapes, history, and heritage. The North Berwick to Dunbar section takes you through some of the best views the county has to offer. The middle of this section goes right past the cottage, and you can walk either the <b>East Linton to North Berwick</b> (climbing <b>North Berwick Law</b> on the way if you wish) or the <b>East Linton to Dunbar</b> section and get the bus back to the village. Check out the route on the link below:
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://johnmuirway.org/route/north-berwick-dunbar' target='_blank' rel='noopener noreferrer'>
      johnmuirway.org/route/north-berwick-dunbar/
    </a>
  </Accordion.Body>
  <Accordion.Body>
    The nearby <b>Lammermuir hills</b> are a must for walkers and offer a strikingly different landscape to the coast. <b>The Herring Road</b> is the most famous old route across the Lammermuirs. When the herring industry was at its peak in the 18th and 19th century, the route was used by fishwives carrying huge creels of herring from Dunbar to the markets in Lauder, and by those travelling to Dunbar to get a stock of salted fish for the winter. <b>The Southern Upland Way</b> follows the Herring Road between Lauder and the Watch Water Reservoir. Check out the links below for these and other trails in the Lammermuirs:
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.lammermuirlife.co.uk/visiting/what-to-do/walking-routes' target='_blank' rel='noopener noreferrer'>
      lammermuirlife.co.uk/visiting/what-to-do/walking-routes
    </a>
    <br/>
    <a href='http://www.elcv.org.uk/wp-content/uploads/2018/02/Paths-in-and-Around-the-Lammermuirs.pdf' target='_blank' rel='noopener noreferrer'>
      elcv.org.uk
    </a>
  </Accordion.Body>
</>

export const places = <>
  <Accordion.Body>
    Below are some of the best days out in the area (see Walking section also):
  </Accordion.Body>
  <Accordion.Body>
    <h4>Preston Mill</h4>
    Just past Prestonkirk on the road out of the village towards Tyninghame, you'll find picturesque Preston Mill. The mill was built around 1599 and is one of the main historical attractions of the area, featuring in recent times in the American hit TV series <b>Outlander</b>.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.nts.org.uk/visit/places/preston-mill' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>East Links Family Park, Dunbar</h4>
    A day out for all the family, this is an activity park suitable for all ages. Activities include go karts, trampolines, soft ball blast area, multi activity fortress, mini golf and a train safari running through the paddocks of friendly farm animals.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.eastlinks.co.uk' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>North Berwick</h4>
    With its two beaches, Law, Scottish Seabird Centre, Lodge Grounds and main street with its many independent shops, cafes and restaurants, North Berwick makes for a great day out. It can be rather busy on a sunny day so parking can be a challenge.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.seabird.org' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    The centre also organises wildlife boat trips which are a wonderful opportunity to spot wildlife or visit one of the islands in the Firth of Forth including the Isle of May and The Bass Rock.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.seabird.org/boats' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    A climb up <b>North Berwick Law</b> is a must on a clear day. Park in the car park at the bottom and follow the grassy path to the top.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.undiscoveredscotland.co.uk/northberwick/northberwicklaw/index.html' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <b>The Coastal Communities Museum</b> explores the culture and heritage of the coastal communities in and around North Berwick.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.coastalmuseum.org' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Hailes Castle</h4>
    Walk along the River Tyne (head down the lane just past the Railway bridge - Distillery Wynd as you are walking out of the village towards Haddington). One of Scotland's oldest remaining stone castles, it dates from the early 1200s and is beautifully set on the bank of the River Tyne. Reputedly, a spot visited by Mary Queen of Scots and her husband to be James Hepburn, it was also the scene of conflict during The Wars of Independence and Oliver Cromwell's. Particularly interesting is the hundreds of years old graffiti. Open all year round at no charge!
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://historicenvironment.scot/visit-a-place/places/hailes-castle' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Tantallon Castle</h4>
    Set right on the cliff edge overlooking The Bass Rock, Tantallon has one of the most dramatic locations in Scotland. Once one of Scotland's strongest fortresses it has a fiery history from its origins in the 1300s to its destruction by Oliver Cromwell's army in the 17th Century.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.historicenvironment.scot/visit-a-place/places/tantallon-castle' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Foxlake Adventures</h4>
    On the edge of the John Muir Country Park, this award-winning adventure hub is just over three miles from the cottage and hosts Scotland's first cable wakeboarding park along with the UK's only ropes course constructed over water. In addition to Wakeboarding, you can try Ringos, Segways and Open Water Swimming. There's also a café with an outdoor seating area.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.foxlake.co.uk' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Dunbar Harbour, Castle & Battery</h4>
    All that remains is the weathered fragmented ruin of what was once one of the mightiest castles in Scotland. You can't access the ruins themselves due the precarious state but the best view is from just below the leisure centre.The much better preserved battery lies at the north-east corner of the Victoria Harbour. This once protected the entrance to the old Dunbar Harbour and now provides a good viewpoint for the town, harbours, and castle. It's a short walk from here to the town's main street with it's shops and cafes.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.undiscoveredscotland.co.uk/dunbar/dunbarcastle/index.html' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>National Museum of Flight, East Fortune</h4>
    Fantastic for a rainy day. The museum is just four and a half miles from the cottage and one of the best flight museums in the UK with its world-class collection of aircraft, including Concorde.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.nms.ac.uk/national-museum-of-flight' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Dunbar Leisure Centre</h4>
    With its wave machine and flume this is another great way to spend a rainy day. There are also regular lane swimming sessions during the week. Check the timetable out on the link below:
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.enjoyleisure.com/venues/c4/dunbar_leisure_pool/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Amisfield Walled Garden, Amisfield Park, Haddington</h4>
    One of the largest walled gardens in Scotland dating from the late 18th Century, this is well worth a visit if you like your gardens. Entry is free and the garden is open all year round except for the Christmas - New Year period.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.amisfield.org.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>NB Distillery, Halflandsbarn, North Berwick</h4>
    From a small start several years ago, NB is now a multi award winning distillery producing artisan gin, vodka and rum. Their Ginspiration Tour will take you on a tour of the distillery followed by a tasting session.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://nbdistillery.com/pages/visit-nb-distillery' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Aberlady Bay Nature Reserve</h4>
    Established in 1952, Aberlady Bay was the first local Nature Reserve. This extensive area with its sand, mudflats and salt marsh is home to feeding wildfowl and waders and breeding birds, in addition to the 550 species of plant life which have been identified here.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.undiscoveredscotland.co.uk/aberlady/aberladybay/index.html' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>And last but not least - Edinburgh</h4>
    The city is within easy reach, a 30-minute drive or a direct bus (2 per hour - great if you want have dinner with a glass or two!!). A day or 2 exploring the city, particularly during the festival is a must.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://edinburgh.org/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
</>

export const eating = <>
  <Accordion.Body>
    There's no shortage of great places to eat in East Linton and the surrounding area. Below is a sample of some tried and tested food options:
  </Accordion.Body>
  <Accordion.Body>
    <h4>The Crown & Kitchen- East Linton</h4>
    A great pub with good food based on local ingredients. Classic Scottish dishes with a modern twist. Dine in the bar, in the restaurant at the back or in the garden in summer.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://crownandkitchen.com' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Bostock Bakery - East Linton</h4>
    The best bread and croissants you'll get this side of the channel. Sourdough bread, bagels and a variety of pastries and cakes. Offering lunchtime treats such as sourdough sandwiches, soup and their famous pork, almond and apple sausage rolls. Open every day but get their early for the best choice.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.bostockbakery.co.uk' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>East Coast Lobsters - Home Delivery</h4>
    Based in the village, this is a fantastic addition to East Linton's dining options and highly recommended.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.eastcoastlobsters.co.uk/collections/menu' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Sri Lankan Delights - Home Delivery</h4>
    Vegan takeaway Sri Lankan Curries delivered to your door on Friday, Saturday, or Sunday night.
  </Accordion.Body>
  <Accordion.Body>
    Order by text or email 07494800538 / srilankandelights@tutanota.com
  </Accordion.Body>
  <Accordion.Body>
    <h4>Wok n Go - East Linton</h4>
    This quirky Chinese restaurant and takeaway is housed in a double decker bus in the car park at The Mart.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.facebook.com/Wok-N-Go-Noodle-Bar-2384536291788198/' target='_blank' rel='noopener noreferrer'>
      link to facebook
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Smeaton Tearoom - East Linton</h4>
    The Victorian tearoom at Smeaton Nursery won 'Best café' in the East Lothian Food and Drink Awards in 2015. The tearoom serves light lunches and a selection of homemade cakes.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.smeatonnurserygardens.co.uk' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>The Linton Steakhouse - East Linton</h4>
    The Linton Steakhouse offers fresh local food, their menu features locally sourced fruit & vegetables, meat & game, and fish & shellfish.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.thelintonhotel.co.uk/the-steakhouse/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Drift Cafe, Canty Bay, North Berwick</h4>
    Situated on the clifftops just past Tantallon on the way to North Berwick, the entrance is easy to miss.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.driftalong.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Tyninghame Smithy - Tyninghame</h4>
    A cosy tearoom in the old blacksmiths with a jumble of tables and exposed brick walls. Popular with walkers and cyclists there are more tables out in the courtyard.
  </Accordion.Body>
  <Accordion.Body>
    <a href='http://facebook.com/TyninghameSmithy' target='_blank' rel='noopener noreferrer'>
      link to facebook
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Lobster Shack - North Berwick</h4>
    Open April to September the Lobster Shack is a takeaway stall (with some basic seating outside) set against the harbour wall.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.lobstershack.co.uk' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Rocketeer - North Berwick</h4>
    The Rocketeer is located in the old coastguard statio, just around the corner in front of the Seabird Centre.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://rocketeerrestaurant.co.uk' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Herringbone - North Berwick</h4>
    Known for its craft beers, cocktails, and simple bistro style food this busy spot is located on North Berwick High Street.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.theherringbone.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Steampunk Café - North Berwick</h4>
    A speciality coffee roaster just behind the high street, operating as a takeaway hatch from their front door for coffee and cakes.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.steampunkcoffee.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Zitto - North Berwick</h4>
    Italian restaurant and wine bar offering a comprehensive variety of traditional homemade dishes and comfort food.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.zitto.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Cucina Amore - North Berwick</h4>
    A popular and well-reviewed restaurant located on the High Street specialising in Italian cuisine.
  </Accordion.Body>
  <Accordion.Body>
    <a href='http://www.cucinaamore.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>The Creel - Dunbar</h4>
    This cosy restaurant specialising in locally sourced food has an excellent reputation and is perfect for lunch or a special dinner.
  </Accordion.Body>
  <Accordion.Body>
    <a href='http://creelrestaurant.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>The Rocks - Dunbar</h4>
    The Rocks is a small hotel with a dramatic coastal outlook. It offers regularly changing menus of delicious, seasonal, locally sourced dishes, specialising in local, freshly-caught seafood, steaks and they serve sirloin beef for their Sunday roast.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.therockshoteldunbar.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Falko - Haddington</h4>
    A small German bakery tucked into the corner of the High Street specialising in premium quality, traditionally made, German Konditorei cakes and gateaux and sourdough breads.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.falko.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Carlyle House - Haddington</h4>
    The café is open daily for breakfast, lunch, and afternoon tea and virtually everything on the menu is made in their own kitchen.
  </Accordion.Body>
  <Accordion.Body>
    <a href='http://carlylehousecafe.com/the-cafe-at-carlyle-house/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Waterside Bistro - Haddington</h4>
    Situated on the banks of the River Tyne next to the historic Nungate Bridge this characterful restaurant, serving lunch and dinner, is a showcase for Scotland's larder.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://thewatersidebistro.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
</>

export const shops = <>
  <Accordion.Body>
    <h4>The Mart Farm Shop, Haddington Road, East Linton</h4>
    Pop into this community hub where you will find free range meat, dairy, artisan cheese and local sustainable fruit and vegetables. They also have a log store selling logs and kindling. Or stay a bit longer enjoy something to eat or drink in their cafe. Delivery & Collection.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://martfarmshop.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Linton Butchers</h4>
    Great local butcher in the High Street, offering high quality meat, an imaginative range of sausages, pies, eggs etc. Closed on Mondays.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Bostock Bakery - East Linton</h4>
    The best bread and croissants you'll get this side of the channel. Sourdough bread, bagels and a variety of pastries and cakes. Offering lunchtime treats such as sourdough sandwiches, soup and their famous pork, almond, and apple sausage rolls. Open every day but get their early for the best choice.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.bostockbakery.co.uk/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Phantassie farm stall beside Bostock Bakery</h4>
    Local East Linton farm produce sold directly to the public on Saturdays 10am - 1pm.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Co-op - East Linton</h4>
    On the corner of the High Street and School Road, the shop has a good range of fresh food, baked goods, papers & magazines and alcoholic drinks. There’s also a cashpoint outside the front of the shop.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Newsagents - East Linton</h4>
    On the High Street just up from the Co-op. Papers, magazines, food basics and logs.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Haddington Farmer's Market</h4>
    Held in Court Street on the last Saturday of the month, from 9am to 1pm the market hosts up to 25 stalls and is an excellent showcase for the best local and seasonal produce. Choose from bacon, sausages, beef, lamb, venison, eggs, fish, pate, charcuterie, handmade ferments, fresh vegetables, plants, crafts, honey, ice cream, cheese, beer, gin, liqueurs, home baking, bread, cakes, pies, ready meals, soap, juice, speciality mushrooms, Jersey cream and butter, chutney, flour, sea salt and gifts.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://www.haddingtonfarmersmarket.co.uk/default.asp?page=home' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
  <Accordion.Body>
    <h4>Dunbar Fish Shop</h4>
    Located on the High Street, this small shop sells a good variety of fresh and frozen fish.
  </Accordion.Body>
  <Accordion.Body>
    <h4>Bellhaven Smokehouse</h4>
    Belhaven Smokehouse is an artisan business, specialising in smoked salmon, trout, mackerel, kippers and cheese.
  </Accordion.Body>
  <Accordion.Body>
    <a href='https://belhavensmokehouse.co.uk/products/' target='_blank' rel='noopener noreferrer'>
      link to website
    </a>
  </Accordion.Body>
</>